/**
 * The shared "not available" experience.
 *
 * One page for a route that does not exist, a task the caller may not see,
 * and a task that never existed — because the server already made those
 * indistinguishable, and a client that dressed them differently would undo
 * that work. No title, type, count or existence hint appears here, only the
 * sentence and a way home.
 */

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useWorkspaceCopy } from '../components.js';

export function NotAvailablePage(): ReactNode {
  const copy = useWorkspaceCopy();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 'var(--space-huge, 96px) var(--space-lg)',
      }}
    >
      <h1
        style={{
          font: 'var(--type-display-md)',
          letterSpacing: 'var(--type-display-md-tracking)',
          color: 'var(--text-primary)',
          marginBottom: 8,
        }}
      >
        {copy.denied.title}
      </h1>
      <p
        style={{
          font: 'var(--type-body-md)',
          color: 'var(--text-secondary)',
          marginBottom: 20,
        }}
      >
        {copy.denied.body}
      </p>
      <Link
        to="/dashboard"
        style={{ color: 'var(--text-link)', font: 'var(--type-body-md)' }}
      >
        {copy.denied.toDashboard}
      </Link>
    </div>
  );
}
